import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";

import { Header } from "../../Shared";
import { NavigationBar } from "../../../helper"
import { GraphTabs } from "./";
// import * as commonApi from "../../../api/commonApi";
import { setSelect } from "../../../store/stylesSlice";

import "../../../assets/stlyes/StudentGraph/StudentGraph.scss";

const StudentGraph = () => {
  const userData = useSelector((state) => state.pupilProgress.pupilInfo);
  // const [teachers, setTeachers] = useState();
  const dispatch = useDispatch();

  // const getUser = async () => {
  //   const getUsers = await commonApi.getTeachersInClass({
  //     id: userData.presentClassId,
  //   });
  //   setTeachers(getUsers);
  // }

  useEffect(() => {
    // getUser();
    dispatch(setSelect(NavigationBar.Pupils))
  }, [])
  return (
    <div className="Page-layout">
      <div className="Page-header">
        <Header />
        <Row className="d-flex flex-column rowStyle">
          {/* <Col>
                    <BreadCrumbs userData={userData} />
                  </Col> */}
          <Col>
            <p className="user">{`${userData.firstName} ${userData.lastName}`}</p>
            <div className="d-flex yearButtondiv">
              <span className="yearButton" style={{ background: "#F34970", color: "#FFF" }}><p>{`Year ${userData.year}`}</p></span>
              {/* <p className="teachers">{Common.Teachers}:
                {
                  teachers && teachers.Items.map((user, k) => <>{k === (teachers.Items.length - 1 && user.name) ? `${user.name}` : `${user.name}, `}</>)
                }
              </p> */}
            </div>
          </Col>
          <Col className="graphTabs">
            <GraphTabs />
          </Col>
        </Row>
      </div>
    </div>
  );
}

export { StudentGraph };